import React from 'react';
import { Skeleton } from '@heroui/react';
import { Widget } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * Placeholder that mirrors the Branches toolbar + grid layout so the page
 * doesn't shift when the real rows swap in.
 */
export const BranchListPageSkeleton: React.FC = () => {
    return (
        <section aria-busy {...getNodeTestIdProp('branch-list-page-loading')}>
            <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <Skeleton className="h-10 w-full rounded-xl sm:w-72" />
                <Skeleton className="h-10 w-32 rounded-xl" />
            </div>
            <Widget
                className="flex flex-col gap-0 overflow-hidden p-0"
                {...getNodeTestIdProp('branch-list-page-loading-widget')}
            >
                <div className="flex flex-col gap-3 p-4">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div
                            className="flex items-center gap-4"
                            key={`branch-list-page-loading-row-${index}`}
                        >
                            <Skeleton className="size-10 rounded-[8px]" />
                            <Skeleton className="h-4 flex-1 rounded-md" />
                            <Skeleton className="h-4 w-40 rounded-md" />
                            <Skeleton className="h-4 w-20 rounded-md" />
                            <Skeleton className="h-4 w-16 rounded-md" />
                            <Skeleton className="h-4 w-16 rounded-md" />
                            <Skeleton className="h-4 w-24 rounded-md" />
                        </div>
                    ))}
                </div>
            </Widget>
        </section>
    );
};
